module.exports = __webpack_public_path__ + "static/media/bermad.626ba468.png";